import { Routes } from '@angular/router';
import { LoginPage } from './pages/login/login';
import { Auth } from './pages/auth/auth';
import { Home } from './pages/home/home';
import { AuthLayout } from './components/auth-layout/auth-layout';
import { AuthGuard } from './services/guards/auth/auth';
import { RolesGuard } from './services/guards/roles/roles';
import { PendingAudit } from './pages/pending-audit/pending-audit';
import { UpsertProviderForm } from './components/provider/upsert-form/upsert-form';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: 'auth',
    component: Auth,
  },
  {
    path: '',
    component: AuthLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [RolesGuard],
        component: Home,
        data: { roles: ['admin', 'provider', 'advisor', 'auditor'] },
      },
      {
        path: 'calentadores/auditoria-pendiente',
        canActivate: [RolesGuard],
        component: PendingAudit,
        data: { roles: ['provider'] },
      },
      {
        path: 'proveedores/crear',
        canActivate: [RolesGuard],
        component: UpsertProviderForm,
        data: { roles: ['admin'] },
      },
    ],
  },
];
